import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { CreditInvoiceFormComponent } from '../../component/credit-invoice-form/credit-invoice-form.component';
import { Observable } from 'rxjs';
import { InvoiceStatus } from '../../model/const/enum';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class CreditInvoiceCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService,
    private _navigation: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      if (command.id !== invoiceCommand.credit) {
        return false;
      }

      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_DELETE_INSTEAD');
        return false;
      }

      if (command.context.isCreditInvoice) {
        this._messageService.showMessage('ERROR.CREDIT_CREDIT_INVOICE');
        return false;
      }

      return true;
    }

    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._actionWindow.open(CreditInvoiceFormComponent, this._injector, null, command.context, true).pipe(
        map(res => {
          this._messageService.showSuccess();
          return true;
        })
      );
    }
  }
}
